import Vue from 'vue';
import {Orion} from '@tailflow/laravel-orion/lib/orion';
import * as VueGoogleMaps from 'vue2-google-maps';
import ResortLocations from '../ResortLocations';

var config = window.config || {
    url: window.location.origin,
    site: 1,
};

Orion.init(config.url, 'sapi');
Orion.setToken('access-token-here');

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDRceJAZP2sctL_LZO1rRbqG1igEsQAWUs',
    },
});

var mountElement = document.getElementById('resort-map-app');

if (mountElement) {
    new Vue({
        el: mountElement,
        components: {
            'resort-locations': ResortLocations,
        },
        data: function ()
        {
            return {
                config: config,
            };
        },
    });
}
